class PageScrollIndicator {

  constructor($main) {
    if (!this.initDomElements($main)) return false;

    this.initScrollWatch();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    return true;
  }

  initScrollWatch() {
    // Variables for scroll calculation
    let ticking = false;
    let lastScrollY = window.scrollY;

    // Function to update scroll indicator height
    const updateScrollIndicator = () => {
      // Get total scrollable height (document height minus viewport height)
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;

      // Calculate scroll percentage (0-100)
      const scrollPercentage = (window.scrollY / scrollHeight) * 100;

      this.domElements.main.css({height: `${scrollPercentage}%`});

      // Reset ticking flag
      ticking = false;
    };

    // Scroll event handler with requestAnimationFrame for performance optimization
    const onScroll = () => {
      lastScrollY = window.scrollY;

      if (!ticking) {
        // Use requestAnimationFrame to optimize performance
        window.requestAnimationFrame(() => {
          updateScrollIndicator();
        });

        ticking = true;
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', onScroll, { passive: true });

    // Initial call to set the indicator height on page load
    updateScrollIndicator();
  }

}

export default PageScrollIndicator;
